import UAParser from 'ua-parser-js';

export const OS_TYPES = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WINDOWS_PHONE: 'WINDOWS_PHONE',
  WINDOWS: 'WINDOWS',
  MAC: 'MAC',
  LINUX: 'LINUX',
  OTHER: 'OTHER',
};

export const BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: 'Firefox',
  IE: 'IE',
  EDGE: 'Edge',
  SAFARI: 'Safari',
  MOBILE_SAFARI: 'Mobile Safari',
  OPERA: 'Opera',
  OTHER: 'Other',
};

function getBrowser(agent) {
  return Object.values(BROWSER_TYPES).find(bt => agent.browser.name === bt) || BROWSER_TYPES.OTHER;
}

const getDevice = agent => agent.device.type?.toLowerCase();

function getOS(agent) {
  const osFamily = (agent.os.name || '').toLowerCase();

  if (!osFamily) {
    return OS_TYPES.OTHER;
  }

  if (osFamily.includes('windows phone')) {
    return OS_TYPES.WINDOWS_PHONE;
  }

  if (osFamily.includes('ios')) {
    return OS_TYPES.IOS;
  }

  if (osFamily.includes('android')) {
    return OS_TYPES.ANDROID;
  }

  if (osFamily.includes('windows')) {
    return OS_TYPES.WINDOWS;
  }

  if (osFamily.includes('linux')) {
    return OS_TYPES.LINUX;
  }

  if (osFamily.includes('mac os') || osFamily.includes('os x')) {
    const browser = getBrowser(agent);
    const device = getDevice(agent);
    if (browser === BROWSER_TYPES.SAFARI && device === 'tablet') {
      // for ipad safari, os type is incorrectly set to MAC on server side.
      // We need to check on client side to know if it is an iOS
      return OS_TYPES.IOS;
    }
    return OS_TYPES.MAC;
  }

  return OS_TYPES.OTHER;
}

const agent = UAParser(navigator.userAgent);

const platform = {
  os: getOS(agent),
  device: getDevice(agent),
  browser: getBrowser(agent),
  version: agent.browser.version,
  majorVersion: parseInt(agent.browser.version, 10),
  // description returns: Chrome 15.0.874 / Mac OS X 10.8.1
  description: `${agent.browser.name} ${agent.browser.version} / ${agent.os.name} ${agent.os.version}`,
  make: agent.device.vendor || 'Unknown',
  model: agent.device.model || agent.browser.name,
};

export default platform;

export const IS_SAFARI = platform.browser === BROWSER_TYPES.SAFARI;
